import styled from "styled-components";

export const Overlay = styled.button`
  position: fixed;
  inset: 0;
  border: none;
  background: rgba(0, 0, 0, 0.5);
  z-index: 69;
`;

export const Container = styled.div`
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  top: 130px;
  z-index: 70;
  background: #363f4a;
  color: #fff;
  border-radius: 16px;
  padding: 20px 16px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
`;

export const Title = styled.div`
  font-size: 16px;
  font-weight: 700;
`;

export const Description = styled.div`
  margin-top: 4px;
  font-size: 14px;
`;

export const Action = styled.button`
  margin-top: 8px;
  border: none;
  background: transparent;
  color: #1f59d8;
  font-weight: 700;
  font-size: 12px;
  cursor: pointer;
  padding: 9px 14px;
`;

